const state = {
  screenWidth: '',
  name: '',
  locale:''
};

export default state;
